<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div
            class="card-header pb-0 d-flex justify-content-between align-items-center"
          >
            <h6>Newsletter Subscribers</h6>
            <button class="btn btn-primary btn-sm mb-0" @click="openSendModal">
              <i class="fas fa-paper-plane me-2"></i> Send Newsletter
            </button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Email
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Subscribed Date
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in subscribers" :key="user.id">
                    <td>
                      <div class="d-flex px-3 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ user.email }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        formatDate(user.created_at)
                      }}</span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="
                          user.is_active
                            ? 'bg-gradient-success'
                            : 'bg-gradient-secondary'
                        "
                      >
                        {{ user.is_active ? "Active" : "Inactive" }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="subscribers.length === 0">
                    <td colspan="3" class="text-center py-4 text-secondary">
                      No subscribers yet.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Send Newsletter Modal -->
    <div
      class="modal fade"
      id="sendModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      ref="sendModalRef"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Send Newsletter</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="form-group mb-3">
              <label>Subject</label>
              <input
                type="text"
                class="form-control"
                v-model="emailForm.subject"
                placeholder="Newsletter Subject"
              />
            </div>
            <div class="form-group mb-3">
              <label>Content (Markdown supported)</label>
              <textarea
                class="form-control"
                rows="10"
                v-model="emailForm.content"
                placeholder="Write your content here..."
              ></textarea>
            </div>
            <div class="alert alert-info text-xss text-white">
              This will be sent to
              <strong>{{ activeSubscribersCount }}</strong> active subscribers.
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="sendEmail"
              :disabled="sending"
            >
              {{ sending ? "Sending..." : "Send Now" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import Swal from "sweetalert2";

export default {
  name: "Newsletter",
  data() {
    return {
      subscribers: [],
      modalInstance: null,
      emailForm: {
        subject: "",
        content: "",
      },
      sending: false,
    };
  },
  computed: {
    activeSubscribersCount() {
      return this.subscribers.filter((s) => s.is_active).length;
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString();
    },
    async fetchSubscribers() {
      try {
        const response = await request.get("/api/admin/newsletter/subscribers");
        if (response.data.success) {
          this.subscribers = response.data.data;
        }
      } catch (e) {
        console.error(e);
      }
    },
    openSendModal() {
      // eslint-disable-next-line
        const Modal = window.bootstrap.Modal;
      const el = document.getElementById("sendModal");
      if (el) {
        this.modalInstance = new Modal(el);
        this.modalInstance.show();
      }
    },
    async sendEmail() {
      if (!this.emailForm.subject || !this.emailForm.content) {
        Swal.fire("Error", "Please fill in subject and content", "error");
        return;
      }

      this.sending = true;
      try {
        const response = await request.post(
          "/api/admin/newsletter/send",
          this.emailForm
        );
        if (response.data.success) {
          Swal.fire("Success", response.data.message, "success");
          this.emailForm.subject = "";
          this.emailForm.content = "";
          this.modalInstance.hide();
        }
      } catch (e) {
        console.error(e);
        Swal.fire("Error", "Failed to send email", "error");
      } finally {
        this.sending = false;
      }
    },
  },
  mounted() {
    this.fetchSubscribers();
  },
};
</script>
